import {
  ACT_INSTANCES_FETCH_ELEMENTS_INIT_ACTION,
  ACT_INSTANCES_FETCH_ELEMENTS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_GET_ELEMENT_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_ADD_ELEMENT_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_DELETE_ELEMENT_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_ELEMENTS_FILTERS,
  ACT_INSTANCES_SET_SELECTED_ELEMENT,
} from '../../constants/actions';

const defaultState = {
  elements: [],
  singleElement: undefined,
  didLoadElements: false,
  isLoadingElements: false,
  isLoadingSingleElement: false,
  isAddingElement: false,
  isDeletingElement: false,
  isElementDeleted: false,
  selectedElement: undefined,
  filters: {
    dynasties: [],
    cities: [],
    tags: [],
  },
};

const elementsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_INSTANCES_FETCH_ELEMENTS_INIT_ACTION:
      return {
        ...state,
        elements: [],
        isLoadingElements: true,
        didLoadElements: false,
      };
    case ACT_INSTANCES_FETCH_ELEMENTS_SUCCESS_ACTION:
      return {
        ...state,
        elements: action.payload,
        isLoadingElements: false,
        didLoadElements: true,
      };
    case ACT_INSTANCES_ADD_ELEMENT_INIT_ACTION:
      return {
        ...state,
        isAddingElement: true,
      };
    case ACT_INSTANCES_ADD_ELEMENT_SUCCESS_ACTION: {
      const newElementsList = state.components.push(action.payload);
      return {
        ...state,
        isAddingElements: false,
        elements: newElementsList,
      };
    }
    case ACT_INSTANCES_GET_ELEMENT_INIT_ACTION:
      return {
        ...state,
        singleElement: undefined,
        isLoadingElements: true,
      };
    case ACT_INSTANCES_GET_ELEMENT_SUCCESS_ACTION:
      return {
        ...state,
        singleElement: action.payload,
        isLoadingSingleElement: false,
      };
    case ACT_INSTANCES_DELETE_ELEMENT_INIT_ACTION:
      return {
        ...state,
        isDeletingElement: true,
        isElementDeleted: false,
      };
    case ACT_INSTANCES_DELETE_ELEMENT_SUCCESS_ACTION:
      return {
        ...state,
        isDeletingElement: false,
        isElementsDeleted: true,
      };
    case ACT_INSTANCES_UPDATE_ELEMENTS_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case ACT_INSTANCES_SET_SELECTED_ELEMENT:
      return {
        ...state,
        selectedElement: action.payload,
      };
    default:
      return state;
  }
};

export default elementsReducer;
